export const calendarEventTemplateHeaders = {
  Events: [
    {
      name: 'Event No.',
      description:
        'A unique number for the event, used to link details from other sheets.',
    },
    { name: 'Summary', description: 'Title of the event.' },
    {
      name: 'Description',
      description: 'Description of the event. Can contain HTML. Optional.',
    },
    {
      name: 'Location',
      description:
        'Geographic location of the event as free-form text. Optional.',
    },
    {
      name: 'Start date time',
      description:
        'The time, as a combined date-time value (formatted according to RFC3339). A time zone offset is required unless a time zone is explicitly specified in timeZone.\nformat: "YYYY-MM-DDThh:mm:ss.SSSZ" or "YYYY-MM-DDThh:mm:ss.SSS±hh:mm"',
    },
    {
      name: 'End date time',
      description:
        'The time, as a combined date-time value (formatted according to RFC3339). A time zone offset is required unless a time zone is explicitly specified in timeZone.\nformat: "YYYY-MM-DDThh:mm:ss.SSSZ" or "YYYY-MM-DDThh:mm:ss.SSS±hh:mm"',
    },
    {
      name: 'All Day Event',
      description: 'Whether this is an all-day event. Accepts TRUE or FALSE.',
    },
    {
      name: 'Visibility',
      description:
        'Visibility of the event. Optional. Possible values are,"default" - Uses the default visibility for events on the calendar. This is the default value.\n"public" - The event is public and event details are visible to all readers of the calendar.\n"private" - The event is private and only event attendees may view event details.\n"confidential" - The event is private. This value is provided for compatibility reasons.',
    },
    {
      name: 'Event type',
      description:
        'Specific type of the event. This cannot be modified after the event is created. Possible values are,"birthday" - A special all-day event with an annual recurrence.\n"default" - A regular event or not further specified.\n"focusTime" - A focus-time event.\n"fromGmail" - An event from Gmail. This type of event cannot be created.\n"outOfOffice" - An out-of-office event.\n"workingLocation" - A working location event.',
    },
    {
      name: 'Add Google Meet',
      description:
        'Whether to add a Google Meet conference to the event. Accepts TRUE or FALSE. Optional.',
    },
  ],
  Attendees: [
    {
      name: 'Event No.',
      description:
        "The number of the event from the 'Events' sheet to which this attendee belongs.",
    },
    {
      name: 'Email',
      description:
        "The attendee's email address, if available. This field must be present when adding an attendee. It must be a valid email address as per RFC5322.Required when adding an attendee.",
    },
    {
      name: 'Display name',
      description: "The attendee's name, if available. Optional.",
    },
    {
      name: 'Optional',
      description:
        'Whether this is an optional attendee. Optional. The default is False.',
    },
  ],
};
